export default __webpack_public_path__ + "static/huawei-0824b357255ced107797ff68fe14df0f.webm";